'use strict';

var NewPooledSeasonalityCalendarDirective = function NewPooledSeasonalityCalendarDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-pooled-seasonality-calendar.html'),
    controller: 'NewPooledSeasonalityCalendarController',
    scope: {
      calendar: '=',
      marketList: '=',
      submitCallback: '='
    },
    link: function link($scope, element) {
      element.on('hidden.bs.modal', function () {
        if ($scope.submitted) {
          $timeout(function () {
            $scope.submitCallback();
            $scope.submitted = false;
          }, 0);
        }
      });
      $scope.openSubmitModal = function () {
        element.find('#submit-for-analysis-modal').modal('show');
      };
      $scope.closeSubmitModal = function () {
        element.find('#submit-for-analysis-modal').modal('hide');
      };
      $scope.setValidationFlag();
      $scope.initMarketsForSpecialEvents();
    }
  };
};
NewPooledSeasonalityCalendarDirective.$inject = ['$timeout'];
module.exports = NewPooledSeasonalityCalendarDirective;